<template>

  <div style="display: flex;justify-content: center;">
    <div/>
    <div id="ht-wrap" class="media1">
      <remote-script src="http://webgl.bz-link.net/lib/plugin/ht-flow.js"></remote-script>
      <remote-script src="http://webgl.bz-link.net/lib/plugin/ht-dashflow.js"></remote-script>
    </div>
  </div>
</template>

<script>
import "../../assets/js/tools/importJs"
export default {
  name: "waterMonitoring",
  data(){
    return{
      dataModel: null,          //数据容器//公共方法属性
      graphView: null,
      dm: null,//2D
      isSyncing: false,
      beforeSwitchStatus: '1',
      actionObject: '',
      //各个商户的水管
      cube_zsms: '',
      cube_main: '',
      cube1: '',
      cube2: '',
      cube_lfgbg: '',
      cube_E: '',
      cube_sttd: '',
      cube_hot: '',
      cube_shower: '',
      cube_wc: '',
      cube_ytcb: '',
      cube_jdcb: '',
      cube_dshf: '',
      cube_back: '',
      offset: '',
      //各个商户水流动画
      main_anmi: '',
      lfgbg_anmi: '',
      e_anmi: '',
      sttd_anmi: '',
      zsms_anmi: '',
      hot_anmi: '',
      dshf_anmi: '',
      shower_anmi: '',
      wc_anmi: '',
      ytcb_anmi: '',
      jdcb_anmi: '',
      back_anmi: '',
      //各个商户的水管开关
      open_lfgbg: '',
      open_e: '',
      open_sttd: '',
      open_hot: '',
      open_dshf: '',
      open_shower: '',
      open_wc: '',
      open_ytcb: '',
      open_jdcb: '',
      open_zsms: '',
      close_lfgbg: '',
      close_e: '',
      close_sttd: '',
      close_hot: '',
      close_dshf: '',
      close_shower: '',
      close_wc: '',
      close_ytcb: '',
      close_jdcb: '',
      close_zsms: '',
      //获取的各个商户接口数据
      obj_lfgbg: '',
      obj_e: '',
      obj_sttd: '',
      obj_hot: '',
      obj_zsms: '',
      obj_dshf: '',
      obj_shower: '',
      obj_wc: '',
      obj_ytcb: '',
      obj_jdcb: '',
      message_flag: false,
      screenWidth: document.body.clientWidth
    }
  },
  beforeCreate() {
    window.htUrl('waterMonitor');
  },
  watch: {
    screenWidth(val) {
      this.reload(val);
      console.log(val)
    }
  },
  mounted() {
    this.addGraphView();
    const that = this;
    setTimeout(() => {
      this.reload(this.screenWidth)
    },30)
    window.onresize = () => (() => {
      console.log(document.body.clientWidth)
      // that.screenWidth = document.body.clientWidth
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        // that.screenWidth = '90vh'
    })();
  },
  methods: {
    reload(screewidth) {
        if (screewidth > 1700) {
          this.dm.getDataByTag("div").setScale(1,1)
          this.dm.getDataByTag("div").p(141,293)
        } else if (screewidth >= 1600 && 1700> screewidth) {
          this.dm.getDataByTag("div").setScale(0.9,0.9)
          this.dm.getDataByTag("div").p(121,273)
        } else if (screewidth >= 1400 && 1600> screewidth) {
          this.dm.getDataByTag("div").setScale(0.8,0.8)
          this.dm.getDataByTag("div").p(101,253)
        } else if (screewidth >= 1230 && 1400> screewidth) {
          this.dm.getDataByTag("div").setScale(0.7,0.7)
          this.dm.getDataByTag("div").p(91,233)
        } else if (screewidth >= 1050 && 1230> screewidth) {
          this.dm.getDataByTag("div").setScale(0.6,0.6)
          this.dm.getDataByTag("div").p(81,213)
        }  else if (screewidth >= 950 && 1050> screewidth) {
          this.dm.getDataByTag("div").setScale(0.5,0.5)
          this.dm.getDataByTag("div").p(81,193)
        } else if (screewidth >= 850 && 950> screewidth) {
          this.dm.getDataByTag("div").setScale(0.4,0.4)
          this.dm.getDataByTag("div").p(81,163)
        } else {
          this.dm.getDataByTag("div").setScale(0.3,0.3)
          this.dm.getDataByTag("div").p(81,133)
        }
    },
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(); // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      this.graphView.addToDOM(document.getElementById('ht-wrap'));
      let _this = this;
      this.graphView.deserialize('displays/demo/水表监测.json',function (){
        _this.float();
        _this.switch();
      });
    },
    float(){
      this.cube_main = this.dm.getDataByTag('cube_main');
      this.cube1 = this.dm.getDataByTag('cube1');
      this.cube2 = this.dm.getDataByTag('cube2');
      this.cube_lfgbg = this.dm.getDataByTag('cube_lfgbg');
      this.cube_E = this.dm.getDataByTag('cube_E');
      this.cube_sttd = this.dm.getDataByTag('cube_sttd');
      this.cube_hot = this.dm.getDataByTag('cube_hot');
      this.cube_zsms = this.dm.getDataByTag('cube_zsms');
      this.cube_shower = this.dm.getDataByTag('cube_shower');
      this.cube_wc = this.dm.getDataByTag('cube_wc');
      this.cube_ytcb = this.dm.getDataByTag('cube_ytcb');
      this.cube_jdcb = this.dm.getDataByTag('cube_jdcb');
      this.cube_dshf = this.dm.getDataByTag('cube_dshf');
      this.cube_back = this.dm.getDataByTag('cube_back');
      this.main_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_main.s('shape.dash.offset');
          this.cube_main.s('shape.dash.offset', this.offset + 3);
          this.cube1.s('shape.dash.offset', this.offset);
          this.cube2.s('shape.dash.offset', -this.offset);
        }
      });
      this.lfgbg_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_lfgbg.s('shape.dash.offset');
          this.cube_lfgbg.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.e_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_E.s('shape.dash.offset');
          this.cube_E.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.sttd_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_sttd.s('shape.dash.offset');
          this.cube_sttd.s('shape.dash.offset', this.offset + 3);
        }
      });
      this.hot_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_hot.s('shape.dash.offset');
          this.cube_hot.s('shape.dash.offset', this.offset + 3);
        }
      });
      this.shower_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_shower.s('shape.dash.offset');
          this.cube_shower.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.wc_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_wc.s('shape.dash.offset');
          this.cube_wc.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.ytcb_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_ytcb.s('shape.dash.offset');
          this.cube_ytcb.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.jdcb_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_jdcb.s('shape.dash.offset');
          this.cube_jdcb.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.dshf_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_dshf.s('shape.dash.offset');
          this.cube_dshf.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.zsms_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_zsms.s('shape.dash.offset');
          this.cube_zsms.s('shape.dash.offset', this.offset - 3);
        }
      });
      this.back_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: ()=>{
          this.offset = this.cube_back.s('shape.dash.offset');
          this.cube_back.s('shape.dash.offset', this.offset - 3);
        }
      });
    },
    switch(){
      this.open_lfgbg =  this.dm.getDataByTag('open_lfgbg');
      this.close_lfgbg =  this.dm.getDataByTag('close_lfgbg');
      this.open_e =  this.dm.getDataByTag('open_e');
      this.close_e =  this.dm.getDataByTag('close_e');
      this.open_sttd =  this.dm.getDataByTag('open_sttd');
      this.close_sttd =  this.dm.getDataByTag('close_sttd');
      this.open_hot =  this.dm.getDataByTag('open_hot');
      this.close_hot =  this.dm.getDataByTag('close_hot');
      this.open_zsms =  this.dm.getDataByTag('open_zsms');
      this.close_zsms =  this.dm.getDataByTag('close_zsms');
      this.open_dshf =  this.dm.getDataByTag('open_dshf');
      this.close_dshf =  this.dm.getDataByTag('close_dshf');
      this.open_shower =  this.dm.getDataByTag('open_shower');
      this.close_shower =  this.dm.getDataByTag('close_shower');
      this.open_wc =  this.dm.getDataByTag('open_wc');
      this.close_wc =  this.dm.getDataByTag('close_wc');
      this.open_ytcb =  this.dm.getDataByTag('open_ytcb');
      this.close_ytcb =  this.dm.getDataByTag('close_ytcb');
      this.open_jdcb =  this.dm.getDataByTag('open_jdcb');
      this.close_jdcb =  this.dm.getDataByTag('close_jdcb');
      this.graphView.mi(e =>{
        if(e.kind === 'clickData'){
          const node = e.data;
          const _tag = node._tag;
          if(_tag === 'open_lfgbg'){
            this.showOpenMessage(this.open_lfgbg,this.close_lfgbg,this.lfgbg_anmi,'a7_b1-w8');
            this.actionObject = '龙福宫宾馆';
          }else if(_tag === 'close_lfgbg'){
            this.showCloseMessage(this.close_lfgbg,this.open_lfgbg,this.lfgbg_anmi,'a7_b1-w8');
            this.actionObject = '龙福宫宾馆';
          }else if(_tag === 'open_e'){
            this.showOpenMessage(this.open_e,this.close_e,this.e_anmi,'a7_b1-w9');
            this.actionObject = 'E座';
          }else if(_tag === 'close_e'){
            this.showCloseMessage(this.close_e,this.open_e,this.e_anmi,'a7_b1-w9');
            this.actionObject = 'E座';
          }else if(_tag === 'open_sttd'){
            this.showOpenMessage(this.open_sttd,this.close_sttd,this.sttd_anmi,'a7_b1-w4');
            this.actionObject = '视通天地';
          }else if(_tag === 'close_sttd'){
            this.showCloseMessage(this.close_sttd,this.open_sttd,this.sttd_anmi,'a7_b1-w4');
            this.actionObject = '视通天地';
          }else if(_tag === 'open_hot'){
            this.showOpenMessage(this.open_hot,this.close_hot,this.hot_anmi,'a7_b1-w3');
            this.actionObject = '热处理小楼';
          }else if(_tag === 'close_hot'){
            this.showCloseMessage(this.close_hot,this.open_hot,this.hot_anmi,'a7_b1-w3');
            this.actionObject = '热处理小楼';
          }else if(_tag === 'open_zsms'){
            this.showOpenMessage(this.open_zsms,this.close_zsms,this.zsms_anmi,'a7_b1-w10');
            this.actionObject = '中商民生';
          }else if(_tag === 'close_zsms'){
            this.showCloseMessage(this.close_zsms,this.open_zsms,this.zsms_anmi,'a7_b1-w10');
            this.actionObject = '中商民生';
          }else if(_tag === 'open_dshf'){
            this.showOpenMessage(this.open_dshf,this.close_dshf,this.dshf_anmi,'a7_b1-w2');
            this.actionObject = '稻盛和夫';
          }else if(_tag === 'close_dshf'){
            this.showCloseMessage(this.close_dshf,this.open_dshf,this.dshf_anmi,'a7_b1-w2');
            this.actionObject = '稻盛和夫';
          }else if(_tag === 'open_shower'){
            this.showOpenMessage(this.open_shower,this.close_shower,this.shower_anmi,'a7_b1-w6');
            this.actionObject = '网二宿舍洗澡间';
          }else if(_tag === 'close_shower'){
            this.showCloseMessage(this.close_shower,this.open_shower,this.shower_anmi,'a7_b1-w6');
            this.actionObject = '网二宿舍洗澡间';
          }else if(_tag === 'open_wc'){
            this.showOpenMessage(this.open_wc,this.close_wc,this.wc_anmi,'a7_b1-w11');
            this.actionObject = '网二厕所';
          }else if(_tag === 'close_wc'){
            this.showCloseMessage(this.close_wc,this.open_wc,this.wc_anmi,'a7_b1-w11');
            this.actionObject = '网二厕所';
          }else if(_tag === 'open_ytcb'){
            this.showOpenMessage(this.open_ytcb,this.close_ytcb,this.ytcb_anmi,'a7_b1-w1');
            this.actionObject = '悠堂串吧';
          }else if(_tag === 'close_ytcb'){
            this.showCloseMessage(this.close_ytcb,this.open_ytcb,this.ytcb_anmi,'a7_b1-w1');
            this.actionObject = '悠堂串吧';
          }else if(_tag === 'open_jdcb'){
            this.showOpenMessage(this.open_jdcb,this.close_jdcb,this.jdcb_anmi,'a7_b1-w5');
            this.actionObject = '聚点串吧';
          }else if(_tag === 'close_jdcb'){
            this.showCloseMessage(this.close_jdcb,this.open_jdcb,this.jdcb_anmi,'a7_b1-w5');
            this.actionObject = '聚点串吧';
          }
        }
      })
    },
    showOpenMessage(switch1,switch2,anmi,tag){
      this.$prompt('请输入密码','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password'
      }).then(({value}) =>{
        this.$post('watermonitoring/setsz',{
          tg: 'TG232',
          column: 'user_name',
          operatePassword: this.$md5(value),
          tag: tag,
          switchStatus: '1',
          beforeSwitchStatus: this.beforeSwitchStatus,
          actionObject: this.actionObject}).then((response)=>{
          if(response !== '密码错误!' && response !== '操作失败') {
            this.beforeSwitchStatus = "1"
            switch1.s('shape.background', '#0d3751')
            switch2.s('shape.background', '#333f52')
            anmi.resume(false)
          }
        })
      })
    },
    showCloseMessage(switch1,switch2,anmi,tag){
      this.$prompt('请输入密码','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password'
      }).then(({value}) =>{
        this.$post('watermonitoring/setsz', {
          tg: 'TG232',
          column: 'user_name',
          operatePassword: this.$md5(value),
          tag: tag,
          switchStatus: '0',
          beforeSwitchStatus: this.beforeSwitchStatus,
          actionObject: this.actionObject}).then((response)=>{
          if(response !== '密码错误!' && response !== '操作失败'){
            this.beforeSwitchStatus = "0"
            switch1.s('shape.background','#0d3751')
            switch2.s('shape.background','#333f52')
            anmi.pause(false)
          }
        })
      })
    },
    initElecData(){
      this.$get('watermonitoring/index',[1,1,9]).then((response)=>{
        this.obj_ytcb = response['TG232:a7_b1-w1']
        this.obj_dshf = response['TG232:a7_b1-w2']
        this.obj_hot = response['TG232:a7_b1-w3']
        this.obj_sttd = response['TG232:a7_b1-w4']
        this.obj_jdcb = response['TG232:a7_b1-w5']
        this.obj_shower = response['TG232:a7_b1-w6']
        this.obj_lfgbg = response['TG232:a7_b1-w8']
        this.obj_e = response['TG232:a7_b1-w9']
        this.obj_zsms = response['TG232:a7_b1-w10']
        this.obj_wc = response['TG232:a7_b1-w11']
        var value_lfgbg = this.dm.getDataByTag('value_lfgbg');
        var value_e = this.dm.getDataByTag('value_e');
        var value_sttd = this.dm.getDataByTag('value_sttd');
        var value_hot = this.dm.getDataByTag('value_hot');
        var value_zsms = this.dm.getDataByTag('value_zsms');
        var value_dshf = this.dm.getDataByTag('value_dshf');
        var value_shower = this.dm.getDataByTag('value_shower');
        var value_wc = this.dm.getDataByTag('value_wc');
        var value_ytcb = this.dm.getDataByTag('value_ytcb');
        var value_jdcb = this.dm.getDataByTag('value_jdcb');

        var v_lfgbg = this.dm.getDataByTag('v_lfgbg');
        var v_e = this.dm.getDataByTag('v_e');
        var v_sttd = this.dm.getDataByTag('v_sttd');
        var v_hot = this.dm.getDataByTag('v_hot');
        var v_zsms = this.dm.getDataByTag('v_zsms');
        var v_dshf = this.dm.getDataByTag('v_dshf');
        var v_shower = this.dm.getDataByTag('v_shower');
        var v_wc = this.dm.getDataByTag('v_wc');
        var v_ytcb = this.dm.getDataByTag('v_ytcb');
        var v_jdcb = this.dm.getDataByTag('v_jdcb');

        value_lfgbg.s('text',this.obj_lfgbg.qf);
        value_e.s('text',this.obj_e.qf);
        value_sttd.s('text',this.obj_sttd.qf);
        value_hot.s('text',this.obj_hot.qf);
        value_zsms.s('text',this.obj_zsms.qf);
        value_dshf.s('text',this.obj_dshf.qf);
        value_shower.s('text',this.obj_shower.qf);
        value_wc.s('text',this.obj_wc.qf);
        value_ytcb.s('text',this.obj_ytcb.qf);
        value_jdcb.s('text',this.obj_jdcb.qf);

        v_lfgbg.s('text',this.obj_lfgbg.bv);
        v_e.s('text',this.obj_e.bv);
        v_sttd.s('text',this.obj_sttd.bv);
        v_hot.s('text',this.obj_hot.bv);
        v_zsms.s('text',this.obj_zsms.bv);
        v_dshf.s('text',this.obj_dshf.bv);
        v_shower.s('text',this.obj_shower.bv);
        v_wc.s('text',this.obj_wc.bv);
        v_ytcb.s('text',this.obj_ytcb.bv);
        v_jdcb.s('text',this.obj_jdcb.bv);

        this.setFloat(this.obj_dshf,this.open_dshf,this.close_dshf,this.dshf_anmi)
        this.setFloat(this.obj_ytcb,this.open_ytcb,this.close_ytcb,this.ytcb_anmi)
        this.setFloat(this.obj_lfgbg,this.open_lfgbg,this.close_lfgbg,this.lfgbg_anmi)
        this.setFloat(this.obj_e,this.open_e,this.close_e,this.e_anmi)
        this.setFloat(this.obj_sttd,this.open_sttd,this.close_sttd,this.sttd_anmi)
        this.setFloat(this.obj_hot,this.open_hot,this.close_hot,this.hot_anmi)
        this.setFloat(this.obj_zsms,this.open_zsms,this.close_zsms,this.zsms_anmi)
        this.setFloat(this.obj_shower,this.open_shower,this.close_shower,this.shower_anmi)
        this.setFloat(this.obj_wc,this.open_wc,this.close_wc,this.wc_anmi)
        this.setFloat(this.obj_jdcb,this.open_jdcb,this.close_jdcb,this.jdcb_anmi)
      })

    },
    setFloat(obj,open,close,anmi){
      if(obj.do == 0){
        close.s('shape.background','#0d3751')
        open.s('shape.background','#333f52')
        anmi.pause(true)
      }else{
        anmi.resume(true)
        open.s('shape.background','#0d3751')
        close.s('shape.background','#333f52')
      }
    }
  }
}
</script>

<style scoped lang="scss">


#ht-wrap{
  position: relative;
  // height: 730px;
  height: 88vh;
  // width: 90vw;
}
.media1{
      width: 90% ;
  }
    @media screen and (width:3440px) and (height: 1440px )   {
      .media1{
      width: 50% ;
        margin-top: 220px;
    }
    }
    @media screen and (width:3840px) and (height: 1080px )   {
      .media1{
      width: 50% ;
    }
    }
</style>